<template>
  <Dialog :open="isOpenRef" @update:open="onOpenChange">
    <DialogContent class="sm:max-w-2xl max-h-[calc(100vh-4rem)] overflow-y-auto">
      <NewSessionContent v-if="isOpenRef" />
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'

import { Dialog, DialogContent } from '@/components/ui/dialog'
import NewSessionContent from '@/features/sessions/components/new-session-modal/new-session-content/new-session-content.vue'
import { selectGetEditSessionModal } from '@/features/ui/store/modal/modal.selectors'
import type { EditSessionModalType } from '@/features/ui/store/modal/modal.store'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { selectGetCurrentRoute } from '@/store/route/route.selector'
import routeStore from '@/store/route/route.store'

const editSessionModalRef = selectGetEditSessionModal(modalsStore)
const isOpenRef = computed(() => !!editSessionModalRef.value?.isOpen)

function onOpenChange(open: boolean) {
  modalsStore.toggleModal('edit-session', open)
  if (!open) {
    modalsStore.updateModalAttachedData<EditSessionModalType>('edit-session', { sessionId: null })
  }
}

const currentRouteRef = selectGetCurrentRoute(routeStore)
watch(currentRouteRef, () => {
  if (isOpenRef.value) {
    modalsStore.toggleModal('edit-session', false)
    modalsStore.updateModalAttachedData<EditSessionModalType>('edit-session', { sessionId: null })
  }
})
</script>
